import e from"styled-components";const i=e.div`
	position: relative;
	border-radius: ${({borderRadius:e})=>`${e}px`};
	display: flex;
	flex-direction: ${({isOneColumn:e})=>e?"row":"column"};
	overflow: hidden;
	height: 100%;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: url(${({imageUrl:e})=>e});
		background-position: center;
		background-size: cover;
		filter: blur(30px) brightness(0.8);
	}
`,o=e.div`
	background-color: black;
	position: absolute;
	inset: 0;
	opacity: ${({opacity:e})=>e};
`,n=e.div`
	padding: 3px;
	z-index: 1;
`,t=e.div`
	background: ${({imageUrl:e})=>`url(${e})`};
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	border-radius: ${({borderRadius:e})=>e-3+"px"};

	${({isOneColumn:e})=>e?"\n      width: 269px;\n      height: 233px;\n      ":"\n      height: 170px;\n  "}
`,r=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 10px;
	z-index: 1;
	height: 100%;
	box-sizing: border-box;
	justify-content: ${({isOneColumn:e})=>e?"space-around":"space-between"};
	padding: ${({isOneColumn:e})=>e?"24px 40px":"12px 14px"};
	flex: ${({isOneColumn:e})=>e?1:"0 1 auto"};
`,d=e.div`
	display: flex;
	flex-direction: column;
	gap: ${({isOneColumn:e})=>e?"0px":"10px"};
`,s=e.h1`
	margin: 0;
	font-size: ${({isOneColumn:e})=>e?"32px":"22px"};
	color: #ffffff;
	font-weight: ${({isOneColumn:e})=>e?600:500};
	max-width: 80%;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,l=e.p`
	margin: 0;
	font-size: 14px;
	line-height: 18px;
	color: rgba(255, 255, 255, 0.6);
	width: 80%;
	white-space: pre-wrap;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,a=e.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:e})=>e};
	background: ${({background:e})=>e};
	border-radius: 9999px;
	width: fit-content;
	max-width: 80%;
	box-sizing: border-box;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-block;
`,p=e.div`
	display: flex;
	justify-content: ${({hasLabel:e})=>e?"space-between":"end"};
	align-items: center;
`,x=e.div`
	opacity: 0.5;

	${({isAbsolute:e})=>e&&"\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n  "}
`;export{x as CardArrowContainer,i as CardContainer,d as CardContent,r as CardContentContainer,t as CardCover,n as CardCoverContainer,p as CardFooter,s as CardHeading,a as CardLabel,o as CardOverlay,l as CardParagraph};
